<template>

<div class="main list-wrapper">

	<h1>{{ $route.name }}</h1>

	<div class="sub-header">
		<div class="input-with-control">
			<input type="text" ref="search_term" v-model="filters.search_term" placeholder="Search..." @keyup.enter="getList(1)" v-focus>
			<div class="button action input-go" @click="getList(1)"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
			<div v-if="showDetail && apiPolicyDetail.api_policy_id" class="detail-title-meta"><label>API Policy ID: </label>{{ apiPolicyDetail.api_policy_id }}</div>
		</div>
	</div>

	<div class="filters" v-if="showFilters">
		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.is_read ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('is_read')"></span>
				<label>Read</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.is_write ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('is_write')"></span>
				<label>Write</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.is_create ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('is_create')"></span>
				<label>Create</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.is_delete ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('is_delete')"></span>
				<label>Delete</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.internal_use_only ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('internal_use_only')"></span>
				<label>Internal Use Only</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.inactive ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('inactive')"></span>
				<label>Inactive</label>
			</li>
		</ul>
		<div class="divider"></div>
		<div class="button action" @click="clearFilters(1)">Clear Filters</div>
		<div v-if="!showDetail" class="button action" @click="newItem()">New Policy</div>
		<div v-if="showDetail" class="button action" @click="backToList()"><i class="fa fa-arrow-circle-left"></i> Back To List</div>
	</div>

	<div v-if="!showDetail" class="list report-list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">API Action</th>
					<th class="list">Description</th>
					<th class="list">API File</th>
					<th class="list">Type</th>
					<th class="list center">Pubic</th>
					<th class="list center">Inactive</th>
				</tr>
			</thead>
			<tr v-for="(action, index) in list" class="clickable-list-item" @click="getItem(action.api_policy_id)">
				<td class="list">{{ action.api_action }}</td>
				<td class="list">{{ action.description }}</td>
				<td class="list">{{ action.api_file }}</td>
				<td class="list">{{ action.api_policy_type_code.capitalizeWords() }}</td>
				<td class="list center"><i v-if="action.public == 1" class="fas fa-check"></i></td>
				<td class="list center"><i v-if="action.inactive == 1" class="fas fa-check"></i></td>
			</tr>
		</table>

	</div>

	<div v-if="showDetail" class="list-detail">
		<label>Select an API Action</label>
		<div class="input-with-control" style="max-width: 1080px;">
			<select v-model="apiPolicyDetail.api_action_id" @change="setAPIActionDetail()">
				<option value="">Select...</option>
				<option v-for="(apiAction, index) in apiActions" :value="apiAction.api_action_id">{{ apiAction.api_action }}</option>
			</select>
			<div class="button action" style="margin: 0 0 0 0.5em;" @click="setNewAPIAction()"><i class="fas fa-plus"></i></div>
		</div>
		<label>API Action</label>
		<input type="text" v-model="apiActionDetail.api_action"/>
		<label>Description</label>
		<textarea v-model="apiActionDetail.description"></textarea>
		<label>API File</label>
		<input type="text" v-model="apiActionDetail.api_file" />
		<div class="two-columns" style="max-width: 1080px; margin: 1.25em 0 0 0;">
			<label class="checkbox">
				<input type="checkbox" v-model="apiActionDetail.public" value="1" ref="api_action_public">
				<span><i class="fas fa-check-circle"></i>Public</span>
			</label>
			<label class="checkbox">
				<input type="checkbox" v-model="apiActionDetail.inactive" value="1" ref="api_action_inactive">
				<span><i class="fas fa-check-circle"></i>Inactive</span>
			</label>
		</div>
		<label>Policy Type</label>
		<div class="four-columns" style="max-width: 1080px;">
            <label v-for="policyType, index) in apiPolicyTypes" class="radio">
				<input type="radio" v-model="apiPolicyDetail.api_policy_type_id" :value="policyType.api_policy_type_id">
				<span><i class="fas fa-check-circle"></i>{{ policyType.description }}</span>
			</label>
		</div>
		<div class="controls">
			<div :class="['button', saving || !canSave ? 'disabled' : 'action']" @click="saveItem()">Save API Policy</div>
			<div class="button cancel" @click="backToList()">Cancel</div>
			<div class="message">{{ message }}</div>
		</div>

	</div>

</div>

</template>

<script>
export default {
	name: 'system-alerts',
	data() {
		return {
            loading: true,
			page: 1,
			showPagination: false,
			showFilters: true,
			filters: {},
			apiActions: [],
			apiPolicyTypes: [],
			list: [],
			paging: {},
			showDetail: false,
			apiPolicyDetail: {},
			apiActionDetail: {},
			saving: false,
			message: ''
		}
	},
	created() {
		this.getAPIActions()
		this.getAPIPolicyTypes()
		this.clearFilters(true)
	},
	computed: {
		canSave() {
			if (this.apiActionDetail.api_action && this.apiActionDetail.api_file && this.apiActionDetail.description && this.apiPolicyDetail.api_policy_type_id) {
				return true
			}
			return false
		}
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				internal_use_only: '',
				inactive: '',
			}
			if (getList) {
				this.getList()
			}
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.filters.page = 1
			this.getList()
		},
		getAPIActions() {
			this.apiCall({ destination: 'get_list_api_actions' }).then(obj => {
				this.apiActions = obj.list
			}).catch(err => {
				console.log(err)
			})
		},
		getAPIPolicyTypes() {
			this.apiCall({ destination: 'get_list_api_policy_types' }).then(obj => {
				this.apiPolicyTypes = obj.list
			}).catch(err => {
				console.log(err)
			})
		},
		getList(page) {
			this.loading = true
			this.apiCall({ destination: 'get_list_api_policies', data: this.filters }).then(obj => {
				this.loading = false
				this.list = obj.list
				this.paging = obj.paging
			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		getItem(apiPolicyId) {
			this.loading = true
			this.apiCall({ destination: 'get_item_api_policy', data: { api_policy_id: apiPolicyId } }).then(obj => {
				this.apiPolicyDetail = obj.api_policy
				this.apiActionDetail = obj.api_action
				this.loading = false
				this.showPagination = false
				this.showDetail = true
			}).catch(err => {
				console.log(err)
			})
		},
		newItem() {
			this.apiPolicyDetail = {
				api_action_id: ''
			}
			this.showPagination = false
			this.showDetail = true
		},
		setNewAPIAction() {
			this.apiPolicyDetail.api_action_id = ''
			this.apiActionDetail = {}
		},
		setAPIActionDetail() {
			if (this.apiPolicyDetail.api_action_id) {
				for (let i = 0; i < this.apiActions.length; i++) {
					if (this.apiActions[i].api_action_id == this.apiPolicyDetail.api_action_id) {
						this.apiActionDetail.api_action = this.apiActions[i].api_action
						this.apiActionDetail.description = this.apiActions[i].description
						this.apiActionDetail.api_file = this.apiActions[i].api_file
						this.apiActionDetail.public = parseInt(this.apiActions[i].public)
						this.apiActionDetail.inactive = parseInt(this.apiActions[i].inactive)
						break;
					}
				}
			} else {
				this.apiActionDetail.api_action = ''
				this.apiActionDetail.description = ''
				this.apiActionDetail.api_file = ''
				this.apiActionDetail.public = 0
				this.apiActionDetail.inactive = 0
			}
		},
		saveItem() {
			if (!this.canSave) { return }
			if (this.saving) { return }
			this.saving = true
			this.apiCall({ destination: 'save_item_api_action', data: this.apiActionDetail }).then(obj => {
				this.message = obj.message
				if (obj.status == 'success') {
					this.apiPolicyDetail.api_action_id = obj.api_action_id
					this.saveAPIPolicy()
				}
			}).catch(err => {
				console.log(err)
			})
		},
		saveAPIPolicy() {
			this.apiCall({ destination: 'save_item_api_policy', data: this.apiPolicyDetail }).then(obj => {
				this.message = obj.message
				if (obj.status == 'success') {
					this.apiPolicyDetail.api_policy_id = obj.api_policy_id
					this.saving = false
				}
			}).catch(err => {
				console.log(err)
			})
		},
		backToList() {
			this.showDetail = false
			this.apiActionDetail = {}
			this.showNewAPIAction = false
			this.newAPIAction = {}
			this.showPagination = this.paging.total_pages > 1
			this.getList()
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
